namespace GeniuzPOS.Inventory {
    export interface IcStockSetAssembleRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        WhsSet?: string;
        WhsItem?: string;
        ExpDate?: string;
        Remark?: string;
        SetItemCode?: string;
        CallSetItemFg?: number;
        SetQty?: number;
        CalDtQtyFg?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ApproveFg?: number;
        ApproveBy?: string;
        ApproveDate?: string;
        PostFg?: PostFgStatus;
        PostDate?: string;
        CancelFg?: CancelFgstatus;
        UseFg?: number;
        QtyUse?: number;
        SetName?: string;
        IcStockSetAssembleDtList?: IcStockSetAssembleDtRow[];
    }

    export namespace IcStockSetAssembleRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SetName';
        export const localTextPrefix = 'Inventory.IcStockSetAssemble';
        export const lookupKey = 'Inventory.IcStockSetAssemble';

        export function getLookup(): Q.Lookup<IcStockSetAssembleRow> {
            return Q.getLookup<IcStockSetAssembleRow>('Inventory.IcStockSetAssemble');
        }
        export const deletePermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';
        export const insertPermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';
        export const readPermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:View';
        export const updatePermission = '2Inventory:การประกอบสินค้า:บันทึกรายการ:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            WhsSet = "WhsSet",
            WhsItem = "WhsItem",
            ExpDate = "ExpDate",
            Remark = "Remark",
            SetItemCode = "SetItemCode",
            CallSetItemFg = "CallSetItemFg",
            SetQty = "SetQty",
            CalDtQtyFg = "CalDtQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ApproveFg = "ApproveFg",
            ApproveBy = "ApproveBy",
            ApproveDate = "ApproveDate",
            PostFg = "PostFg",
            PostDate = "PostDate",
            CancelFg = "CancelFg",
            UseFg = "UseFg",
            QtyUse = "QtyUse",
            SetName = "SetName",
            IcStockSetAssembleDtList = "IcStockSetAssembleDtList"
        }
    }
}
